import { Nationality } from '../../dto/SearchTagDto';

export type EditableRow = {
	nationality: Nationality | '';
	document: string;
	title: string;
	email: string;
};

export const EMPTY_ROW: EditableRow = {
	nationality: '',
	document: '',
	title: '',
	email: '',
};
